module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAALCAYAAABGbhwYAAAAAXNSR0IArs4c6QAAAR5JREFUKFNd0dtKAzEQBuCZKXQfxBfwUM+Hh7Dbgoh3SSYXvoIHUJSiSG9Kl8CyfQe9Ed/IQ9XLJbuJRDZLde4CX5KZf5CZj6qqes7zfA4AIKU8RsQnY8x3OMdCKeU6Io46nU5/Op1+aq13nXOXAJAuYgw3lFKbAHAbsVJqDwAuFvEvDMXM2wBwXZZlfzabfQkh9onoPOIWNv3tENGV9/4wfMvMB977syRJ+n9ggyUi9owx3LR1CgBL/19cRsQxEQ2zLHtl5p5z7g4RBy3UWq8458bW2rQoijet9UZd16Nut5tOJpOPOPUqADxYawcBCSG2iOimrus05otCiDVEvK+qahhQnJ6I0pBrG3jYjPf+xRjz3gxzYq19DBEtbuYHWDyOaKfqxjcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/right.png
// module id = R8sl
// module chunks = 1